<template>
  <div>
    <OpaModal width="900" height="540" v-model="value" header="Novo Banner">
      <div style="height:370px;overflow:auto; padding:20px;">
        <table>
          <tr style="height: 104px; width:200px">
            <td>
              Adicionar Link Externo:
            </td>
            <td>
              <div style="text-decoration:underline;cursor:pointer;">
                <input type="url" placeholder="https://www.google.com.br" v-model="inputBanner.link">
              </div>
              <div v-if="inputBanner.link && inputBanner.type === 'hero_banner'" style="text-decoration:underline;cursor:pointer;" @click="delete inputBanner.link; $forceUpdate()">
                remover link
              </div>
            </td>
          </tr>
          <tr>
            <td>Imagem</td>
            <td style="height:300px;">
              <OpaDragImage @uploadImage="(image) => saveImageNewHeroBanner(image, 'image')"/>
            </td>
            <td>
              <img v-if="inputBanner.image" :src="getImage(inputBanner, 'image') " style="max-width:400px;">
            </td>
          </tr>
        </table>
      </div>
      <div class="modal_footer">
        <button class="buttonFlat" style="width:80px;float:right;margin:20px;margin-right:20px;" @click="saveHeroBanner();">Salvar</button>
        <button class="buttonWire" style="width:80px;float:right;margin:20px;margin-right:0px;" @click="$emit('close');">Cancelar</button>
      </div>
    </OpaModal>
  </div>
</template>

<script>
  import OpaModal from '@/components/OpaModal.vue'
  import OpaDragImage from '@/components/OpaDragImage.vue'
  import {EventBus} from '@/utils/event-bus'
  import axios from 'axios'
  import {mapGetters} from 'vuex'

  export default {
    name: 'OpaImg',
    props: [
      "value",
      "inputBanner",
    ],

    data() {
      return {
        modalBanner: true,
      }
    },

    components: {
      OpaModal,
      OpaDragImage
    },

    methods: {
      ...mapGetters(['getAdmin', 'getCompany', 'getOpaApi']),

      saveHeroBanner() {
        console.log(this.inputBanner)
        this.$emit('saveHeroBanner', this.inputBanner)
      },

      getImage(banner) {
        return 'https://' + this.getCompany().Id + '/img/' + this.getCompany().companyId + '/banner/' + banner.image
      },

      saveImageNewHeroBanner(file) {
        console.log('NEW FILE => ', file)
        let vm = this
        let bodyFormData = new FormData()
        bodyFormData.append('file', file)
        EventBus.$emit('showLoading', true)
        axios({
          method: 'post',
          url: this.getOpaApi() + '/files/company/' + this.getCompany().companyId + '/banner',
          data: bodyFormData,
          config: {headers: {'Content-Type': 'form-data'}}
        })
          .then(function (response) {
            console.log('banner file', response.data)
            vm.inputBanner.image = response.data.file_name
            EventBus.$emit('showLoading', false)
          })
          .catch(function (response) {
            console.log(response)
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'error', 'erro ao subir imagem')
          })
      },

      updateBannerData(banner) {
        let vm = this
        axios.put(this.getOpaApi() + '/company/banner/' + this.getCompany().Id, banner)
          .then((response) => {
            vm.$store.commit('setCompany', response.data)
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'success', 'banner atualizado')
          })
          .catch((e) => {
            console.log('ERROR', e)
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'error', 'erro ao atualizar banner')
          })
      }
    }
  }
</script>

<style lang="scss" scoped>
  input[type='file'] {
    display: none;
  }

  label {
    cursor: pointer;
    text-decoration: underline;
  }
</style>
